import {Box, Button} from '@mui/material';
import React from 'react';
import {AddPoolHoursModal} from './components/AddPoolHoursModal';
import {ScheduleCallModal} from './components/ScheduleCallModal';
import {StatusCallDrawer} from './components/StatusCallDrawer';
import {StatusCallsCalendarView} from './components/StatusCallsCalendarView';
import {useStatusCallsPageState} from './state/status-calls-page-state';

export const StatusCallsPage = () => {
  const state = useStatusCallsPageState();

  return (
    <Box sx={{width: '100%'}}>
      <Box display="flex" alignItems="center" justifyContent="flex-end" gap={1} mb={2}>
        <Button variant="outlined" onClick={() => state.setAddHoursModalOpen(true)}>
          {state.translateLocal('button.add-hours')}
        </Button>
        <Button
          variant="contained"
          onClick={() => {
            state.setPrefilledScheduleAt(null);
            state.setScheduleModalOpen(true);
          }}
        >
          {state.translateLocal('button.schedule')}
        </Button>
      </Box>

      <StatusCallsCalendarView
        calls={state.calendarCalls}
        onCallClick={(call) => {
          state.setSelectedCall(call);
          state.setDrawerOpen(true);
        }}
        onSlotClick={(scheduledAtIso) => {
          state.setPrefilledScheduleAt(scheduledAtIso);
          state.setScheduleModalOpen(true);
        }}
        onDateRangeChanged={(from, to) => state.setCalendarRange({from, to})}
      />

      {state.selectedCall && (
        <StatusCallDrawer
          call={state.selectedCall}
          open={state.isDrawerOpen}
          onClose={() => {
            state.setDrawerOpen(false);
            state.setSelectedCall(null);
          }}
          onChanged={state.refreshCalendar}
          translate={state.translate}
          translateLocal={state.translateLocal}
        />
      )}

      <ScheduleCallModal
        open={state.isScheduleModalOpen}
        prefilledScheduleAt={state.prefilledScheduleAt}
        onClose={() => state.setScheduleModalOpen(false)}
        onSuccess={state.refreshCalendar}
        translateLocal={state.translateLocal}
      />

      <AddPoolHoursModal
        open={state.isAddHoursModalOpen}
        onClose={() => state.setAddHoursModalOpen(false)}
        onSuccess={state.refreshCalendar}
        translateLocal={state.translateLocal}
      />
    </Box>
  );
};
